// extracted by mini-css-extract-plugin
export default {"cls1":"cmHfHqx4Nbl2TdXzQIAK","cls2":"JtiHsGHyXoviIPIVDRuV cmHfHqx4Nbl2TdXzQIAK"};